import React from 'react'
import {Trans} from "react-i18next";

const MainFooter = () => {
  return (
      <footer className="o-footer omp-no-marging" id="footer" role="contentinfo">
          <div className="o-footer-top omp-no-padding-footer">
              <div className="container-fluid">
                  <div className="row">
                      <ul className="nav align-items-center">
                          <li className="nav-item"><span className="nav-link"><Trans>header_menu_followus</Trans></span></li>
                          <li className="nav-item ml-2"><a className="nav-link btn btn-inverse btn-social btn-facebook" href="http://www.facebook.com/OrangeCameroun" rel="noreferrer" target="_blank"></a></li>
                          <li className="nav-item ml-2"><a className="nav-link btn btn-inverse btn-social btn-instagram" href="https://www.instagram.com/orangecameroun/" rel="noreferrer" target="_blank"></a></li>
                          <li className="nav-item ml-2"><a className="nav-link btn btn-inverse btn-social btn-twitter" href="https://twitter.com/Orange_Cameroun" rel="noreferrer" target="_blank"></a></li>
                          <li className="nav-item ml-2"><a className="nav-link btn btn-inverse btn-social btn-youtube" href="https://www.youtube.com/channel/UCuhuxcAProlwzAVelJVrjxw" rel="noreferrer" target="_blank"></a></li>
                      </ul>
                  </div>
              </div>
          </div><div className="dropdown-divider"></div>
          <div className="o-footer-bottom omp-no-padding-footer">
              <div className="container-fluid">
                  <div className="row">
                      <ul className="nav align-items-center">
                          <li className="nav-item"><span className="nav-link">© Orange 2021</span></li>
                          <li className="nav-item"><a className="nav-link" href="http://www.orange.com/fr/Groupe/Presence-mondiale/Pays/Bienvenue-chez-Orange-Cameroun" rel="noreferrer" target="_blank"><Trans>header_menu_aboutocm</Trans></a></li>
                          <li className="nav-item"><a className="nav-link" href="http://www.orange.cm/2/particuliers/1/4/mentions-legales-627.html" rel="noreferrer" target="_blank"><Trans>header_menu_mentionlegal</Trans></a></li>
                          <li className="nav-item"><a className="nav-link" href="http://www.orange.cm" rel="noreferrer" target="_blank">Orange.cm</a></li>
                          <li className="nav-item"><a className="nav-link" href="https://orange.jobs/site/fr-home/" rel="noreferrer" target="_blank">Orange jobs</a></li>
                          <li className="nav-item"><a className="nav-link" href="http://www.fondationorange.com/+-Cameroun-32-+" rel="noreferrer" target="_blank"><Trans>header_menu_ocmfoundation</Trans></a></li>
                      </ul>
                  </div>
              </div>
          </div>
      </footer>
  )
}

export default React.memo(MainFooter)
